import axios from "./utils";


export const bingoData = (requestData) => {
  return axios.get(`/v1/lottery/history/bingo`, { params: requestData });
};

export const m539Data = (requestData) => {
  return axios.get(`/v1/lottery/history/m539`, { params: requestData });
};